module.exports = __webpack_public_path__ + "f55c3f2a62fdb6e4ceeb0032f4afc37e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/huagong_c.png
// module id = 278
// module chunks = 3